import axios from "axios";

export function FetchLexisNexisOfflinePost(es_id, callback) {
    return function (dispatch) {
        axios
            .get("https://api2.radarr.com:3020/common/get-es-posts?_ids=" + es_id, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                callback(true, response.data.result.hits.hits[0]);
            })
            .catch((error) => {
                console.log(error);
                callback(false);
            });
    };
}
